module.exports = __webpack_public_path__ + "img/myketLight.26e0edc5.svg";